import { render, staticRenderFns } from "./OpportunitiesDrilldownTable.vue?vue&type=template&id=7c873e7d&scoped=true&"
import script from "./OpportunitiesDrilldownTable.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesDrilldownTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c873e7d",
  null
  
)

export default component.exports